import React, { useEffect, useMemo, useState } from "react";
import api from "../../api/api";
import Swal from "sweetalert2";

import {
Document,
Page,
Text,
View,
Image,
StyleSheet,
} from "@react-pdf/renderer";

import {
Box,
Typography,
Paper,
Button,
Modal,
TextField,
MenuItem,
Table,
TableBody,
TableCell,
TableContainer,
TableHead,
TableRow,
TablePagination,
Grid,
IconButton,
InputAdornment,
Card,
CardContent,
Chip,
Divider,
CircularProgress,
useMediaQuery,
useTheme,
} from "@mui/material";

import {
Download,
Search,
Delete,
Add,
AccountBalanceWallet,
TrendingUp,
Payments,
Warning,
Close,
} from "@mui/icons-material";

import {
BarChart,
Bar,
XAxis,
YAxis,
Tooltip,
ResponsiveContainer,
Legend,
CartesianGrid,
} from "recharts";

import { PDFDownloadLink } from "@react-pdf/renderer";

import logo from "./savationChristLogo.png";

const semesters = ["First", "Second"];
const currentYear = new Date().getFullYear();

const COLORS = {
orange: "#F28C28",
orangeDark: "#D96F0B",
black: "#111111",
dark: "#1B1B1B",
gray: "#F4F5F7",
grayDark: "#6B7280",
camel: "#C19A6B",
camelLight: "#E8D5BD",
white: "#FFFFFF",
green: "#16803C",
red: "#C62828",
};

const pdfStyles = StyleSheet.create({
page: {
padding: 32,
fontFamily: "Helvetica",
backgroundColor: "#FFFFFF",
},

header: {
padding: 18,
borderRadius: 8,
backgroundColor: "#111111",
flexDirection: "row",
alignItems: "center",
marginBottom: 20,
},

logo: {
width: 55,
height: 55,
marginRight: 15,
},

headerContent: {
flex: 1,
},

schoolName: {
color: "#FFFFFF",
fontSize: 18,
fontWeight: "bold",
marginBottom: 5,
},

schoolInfo: {
color: "#E8D5BD",
fontSize: 8,
marginBottom: 3,
},

reportTitle: {
fontSize: 16,
fontWeight: "bold",
color: "#111111",
textAlign: "center",
marginBottom: 18,
},

summaryContainer: {
flexDirection: "row",
gap: 10,
marginBottom: 18,
},

summaryCard: {
flex: 1,
padding: 10,
borderRadius: 6,
backgroundColor: "#F4F5F7",
borderLeftWidth: 4,
borderLeftColor: "#F28C28",
},

summaryLabel: {
fontSize: 8,
color: "#6B7280",
marginBottom: 5,
},

summaryValue: {
fontSize: 13,
fontWeight: "bold",
color: "#111111",
},

table: {
width: "100%",
borderWidth: 1,
borderColor: "#D1D5DB",
},

tableHeader: {
flexDirection: "row",
backgroundColor: "#111111",
color: "#FFFFFF",
paddingVertical: 8,
},

tableRow: {
flexDirection: "row",
borderTopWidth: 1,
borderTopColor: "#E5E7EB",
paddingVertical: 8,
},

tableRowAlt: {
backgroundColor: "#F9FAFB",
},

cell: {
fontSize: 8,
paddingHorizontal: 5,
textAlign: "center",
},

headerCell: {
color: "#FFFFFF",
fontSize: 8,
fontWeight: "bold",
paddingHorizontal: 5,
textAlign: "center",
},

colNumber: {
width: "6%",
},

colClass: {
width: "21%",
},

colSemester: {
width: "15%",
},

colYear: {
width: "12%",
},

colAmount: {
width: "15.33%",
},

signatureArea: {
marginTop: 55,
flexDirection: "row",
justifyContent: "space-between",
},

signature: {
width: 180,
borderTopWidth: 1,
borderTopColor: "#111111",
paddingTop: 6,
textAlign: "center",
fontSize: 9,
},

footer: {
position: "absolute",
bottom: 20,
left: 32,
right: 32,
borderTopWidth: 1,
borderTopColor: "#E5E7EB",
paddingTop: 7,
textAlign: "center",
color: "#6B7280",
fontSize: 8,
},
});

const FinancePDF = ({ feesData }) => {
const totalExpected = feesData.reduce(
(sum, item) => sum + Number(item.fees_expected || 0),
0
);

const totalCollected = feesData.reduce(
(sum, item) => sum + Number(item.fees_collected || 0),
0
);

const totalBalance = feesData.reduce(
(sum, item) => sum + Number(item.balance || 0),
0
);

return ( <Document> <Page size="A4" orientation="portrait" style={pdfStyles.page}> <View style={pdfStyles.header}> <Image src={logo} style={pdfStyles.logo} />


      <View style={pdfStyles.headerContent}>
        <Text style={pdfStyles.schoolName}>
          Messiah Mission Institute
        </Text>

        <Text style={pdfStyles.schoolInfo}>
          Morris' Farm, Paynesville, Monrovia, Liberia
        </Text>

        <Text style={pdfStyles.schoolInfo}>
          Contact: +231-770-216-549 / +231-770-405-998 / +231-886-484-807
        </Text>

        <Text style={pdfStyles.schoolInfo}>
          messiahmissioninstitute@gmail.com
        </Text>
      </View>
    </View>

    <Text style={pdfStyles.reportTitle}>
      Semester Financial Summary Report
    </Text>

    <View style={pdfStyles.summaryContainer}>
      <View style={pdfStyles.summaryCard}>
        <Text style={pdfStyles.summaryLabel}>
          TOTAL NET FEES
        </Text>

        <Text style={pdfStyles.summaryValue}>
          ${totalExpected.toLocaleString("en-US")}
        </Text>
      </View>

      <View style={pdfStyles.summaryCard}>
        <Text style={pdfStyles.summaryLabel}>
          TOTAL FEES PAID
        </Text>

        <Text style={pdfStyles.summaryValue}>
          ${totalCollected.toLocaleString("en-US")}
        </Text>
      </View>

      <View style={pdfStyles.summaryCard}>
        <Text style={pdfStyles.summaryLabel}>
          TOTAL ARREARS
        </Text>

        <Text style={pdfStyles.summaryValue}>
          ${totalBalance.toLocaleString("en-US")}
        </Text>
      </View>
    </View>

    <View style={pdfStyles.table}>
      <View style={pdfStyles.tableHeader}>
        <Text style={[pdfStyles.headerCell, pdfStyles.colNumber]}>
          #
        </Text>

        <Text style={[pdfStyles.headerCell, pdfStyles.colClass]}>
          Class
        </Text>

        <Text style={[pdfStyles.headerCell, pdfStyles.colSemester]}>
          Semester
        </Text>

        <Text style={[pdfStyles.headerCell, pdfStyles.colYear]}>
          Year
        </Text>

        <Text style={[pdfStyles.headerCell, pdfStyles.colAmount]}>
          Net Fees
        </Text>

        <Text style={[pdfStyles.headerCell, pdfStyles.colAmount]}>
          Paid
        </Text>

        <Text style={[pdfStyles.headerCell, pdfStyles.colAmount]}>
          Arrears
        </Text>
      </View>

      {feesData.map((row, index) => (
        <View
          key={row.id}
          style={[
            pdfStyles.tableRow,
            index % 2 === 1 && pdfStyles.tableRowAlt,
          ]}
        >
          <Text style={[pdfStyles.cell, pdfStyles.colNumber]}>
            {index + 1}
          </Text>

          <Text style={[pdfStyles.cell, pdfStyles.colClass]}>
            {row.grade_class_name}
          </Text>

          <Text style={[pdfStyles.cell, pdfStyles.colSemester]}>
            {row.semester}
          </Text>

          <Text style={[pdfStyles.cell, pdfStyles.colYear]}>
            {row.year}
          </Text>

          <Text style={[pdfStyles.cell, pdfStyles.colAmount]}>
            ${Number(row.fees_expected || 0).toLocaleString("en-US")}
          </Text>

          <Text style={[pdfStyles.cell, pdfStyles.colAmount]}>
            ${Number(row.fees_collected || 0).toLocaleString("en-US")}
          </Text>

          <Text style={[pdfStyles.cell, pdfStyles.colAmount]}>
            ${Number(row.balance || 0).toLocaleString("en-US")}
          </Text>
        </View>
      ))}
    </View>

    <View style={pdfStyles.signatureArea}>
      <Text style={pdfStyles.signature}>
        Business Manager
      </Text>

      <Text style={pdfStyles.signature}>
        The Finance Department
      </Text>
    </View>

    <Text style={pdfStyles.footer}>
      Generated by Messiah Mission Institute Finance Department
    </Text>
  </Page>
</Document>


);
};

const FinanceDashboard = () => {
const theme = useTheme();
const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

const [feesData, setFeesData] = useState([]);
const [formData, setFormData] = useState({
grade_class: "",
semester: "",
year: currentYear,
});

const [gradeClasses, setGradeClasses] = useState([]);
const [open, setOpen] = useState(false);
const [searchTerm, setSearchTerm] = useState("");
const [page, setPage] = useState(0);
const [rowsPerPage, setRowsPerPage] = useState(6);
const [loading, setLoading] = useState(true);
const [saving, setSaving] = useState(false);

const fetchFees = async () => {
try {
const res = await api.get("/fees-per-grade-class/");
setFeesData(res.data);
} catch (error) {
console.error("Failed to fetch fees:", error);


  Swal.fire(
    "Error",
    "Failed to load financial records.",
    "error"
  );
}


};

const fetchGradeClasses = async () => {
try {
const res = await api.get("/api/users/grade-classes/");
setGradeClasses(res.data);
} catch (error) {
console.error("Failed to fetch grade classes:", error);
}
};

const loadDashboard = async () => {
setLoading(true);


await Promise.all([
  fetchFees(),
  fetchGradeClasses(),
]);

setLoading(false);


};

useEffect(() => {
loadDashboard();
}, []);

const handleSubmit = async () => {
if (
!formData.grade_class ||
!formData.semester ||
!formData.year
) {
Swal.fire(
"Incomplete Form",
"Please complete all required fields.",
"warning"
);


  return;
}

try {
  setSaving(true);

  await api.post(
    "/fees-per-grade-class/",
    formData
  );

  setOpen(false);

  setFormData({
    grade_class: "",
    semester: "",
    year: currentYear,
  });

  await fetchFees();

  Swal.fire(
    "Success",
    "Financial summary added successfully.",
    "success"
  );
} catch (error) {
  console.error("Failed to save:", error);

  Swal.fire(
    "Error",
    "Failed to save financial summary.",
    "error"
  );
} finally {
  setSaving(false);
}


};

const handleDelete = async (id) => {
const result = await Swal.fire({
title: "Delete financial record?",
text: "This action cannot be undone.",
icon: "warning",
showCancelButton: true,
confirmButtonColor: COLORS.orangeDark,
cancelButtonColor: COLORS.black,
confirmButtonText: "Yes, delete it",
});


if (!result.isConfirmed) return;

try {
  await api.delete(
    `/fees-per-grade-class/${id}/`
  );

  setFeesData((prev) =>
    prev.filter((item) => item.id !== id)
  );

  Swal.fire(
    "Deleted",
    "Financial record deleted successfully.",
    "success"
  );
} catch (error) {
  console.error("Failed to delete:", error);

  Swal.fire(
    "Error",
    "Failed to delete record.",
    "error"
  );
}


};

const filteredData = useMemo(() => {
return feesData.filter((item) =>
item.grade_class_name
?.toLowerCase()
.includes(searchTerm.toLowerCase())
);
}, [feesData, searchTerm]);

const totalExpected = useMemo(() => {
return feesData.reduce(
(sum, item) =>
sum + Number(item.fees_expected || 0),
0
);
}, [feesData]);

const totalCollected = useMemo(() => {
return feesData.reduce(
(sum, item) =>
sum + Number(item.fees_collected || 0),
0
);
}, [feesData]);

const totalBalance = useMemo(() => {
return feesData.reduce(
(sum, item) =>
sum + Number(item.balance || 0),
0
);
}, [feesData]);

const collectionRate =
totalExpected > 0
? Math.round(
(totalCollected / totalExpected) * 100
)
: 0;

const chartData = feesData.map((item) => ({
name: item.grade_class_name,
expected: Number(item.fees_expected || 0),
collected: Number(item.fees_collected || 0),
balance: Number(item.balance || 0),
}));

const handleChangePage = (event, newPage) => {
setPage(newPage);
};

const handleChangeRowsPerPage = (event) => {
setRowsPerPage(
parseInt(event.target.value, 10)
);


setPage(0);


};

return (
<Box
sx={{
minHeight: "100vh",
backgroundColor: "#F5F6F8",
p: {
xs: 1.5,
sm: 2,
md: 3,
},
}}
>
<Box
sx={{
maxWidth: 1600,
mx: "auto",
}}
>
<Paper
elevation={0}
sx={{
p: {
xs: 2,
sm: 3,
},
mb: 3,
borderRadius: 3,
color: COLORS.white,
background: `linear-gradient(135deg, ${COLORS.black} 0%, #292929 100%)`,
position: "relative",
overflow: "hidden",
}}
>
<Box
sx={{
position: "absolute",
right: -70,
top: -100,
width: 250,
height: 250,
borderRadius: "50%",
backgroundColor: "rgba(242, 140, 40, 0.15)",
}}
/>


      <Box
        sx={{
          position: "relative",
          zIndex: 1,
        }}
      >
        <Typography
          sx={{
            fontSize: {
              xs: 23,
              sm: 30,
              md: 36,
            },
            fontWeight: 800,
            letterSpacing: "-0.5px",
          }}
        >
          Finance Dashboard
        </Typography>

        <Typography
          sx={{
            mt: 0.5,
            color: COLORS.camelLight,
            fontSize: {
              xs: 13,
              sm: 15,
            },
          }}
        >
          Monitor semester fees, collections, and outstanding balances.
        </Typography>
      </Box>
    </Paper>

    <Grid
      container
      spacing={2}
      sx={{ mb: 3 }}
    >
      <Grid item xs={12} sm={6} md={3}>
        <Card
          sx={{
            height: "100%",
            borderRadius: 3,
            border: "1px solid #E5E7EB",
            boxShadow: "0 8px 25px rgba(0,0,0,0.05)",
          }}
        >
          <CardContent>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Box>
                <Typography
                  color="text.secondary"
                  fontSize={13}
                >
                  Net Fees
                </Typography>

                <Typography
                  sx={{
                    mt: 1,
                    fontSize: {
                      xs: 22,
                      sm: 26,
                    },
                    fontWeight: 800,
                  }}
                >
                  ${totalExpected.toLocaleString("en-US")}
                </Typography>
              </Box>

              <Box
                sx={{
                  width: 48,
                  height: 48,
                  borderRadius: 2,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "#FFF1E3",
                  color: COLORS.orange,
                }}
              >
                <AccountBalanceWallet />
              </Box>
            </Box>
          </CardContent>
        </Card>
      </Grid>

      <Grid item xs={12} sm={6} md={3}>
        <Card
          sx={{
            height: "100%",
            borderRadius: 3,
            border: "1px solid #E5E7EB",
            boxShadow: "0 8px 25px rgba(0,0,0,0.05)",
          }}
        >
          <CardContent>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Box>
                <Typography
                  color="text.secondary"
                  fontSize={13}
                >
                  Fees Collected
                </Typography>

                <Typography
                  sx={{
                    mt: 1,
                    fontSize: {
                      xs: 22,
                      sm: 26,
                    },
                    fontWeight: 800,
                    color: COLORS.green,
                  }}
                >
                  ${totalCollected.toLocaleString("en-US")}
                </Typography>
              </Box>

              <Box
                sx={{
                  width: 48,
                  height: 48,
                  borderRadius: 2,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "#EAF7EE",
                  color: COLORS.green,
                }}
              >
                <Payments />
              </Box>
            </Box>
          </CardContent>
        </Card>
      </Grid>

      <Grid item xs={12} sm={6} md={3}>
        <Card
          sx={{
            height: "100%",
            borderRadius: 3,
            border: "1px solid #E5E7EB",
            boxShadow: "0 8px 25px rgba(0,0,0,0.05)",
          }}
        >
          <CardContent>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Box>
                <Typography
                  color="text.secondary"
                  fontSize={13}
                >
                  Outstanding
                </Typography>

                <Typography
                  sx={{
                    mt: 1,
                    fontSize: {
                      xs: 22,
                      sm: 26,
                    },
                    fontWeight: 800,
                    color: COLORS.red,
                  }}
                >
                  ${totalBalance.toLocaleString("en-US")}
                </Typography>
              </Box>

              <Box
                sx={{
                  width: 48,
                  height: 48,
                  borderRadius: 2,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "#FDECEC",
                  color: COLORS.red,
                }}
              >
                <Warning />
              </Box>
            </Box>
          </CardContent>
        </Card>
      </Grid>

      <Grid item xs={12} sm={6} md={3}>
        <Card
          sx={{
            height: "100%",
            borderRadius: 3,
            border: "1px solid #E5E7EB",
            boxShadow: "0 8px 25px rgba(0,0,0,0.05)",
          }}
        >
          <CardContent>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Box>
                <Typography
                  color="text.secondary"
                  fontSize={13}
                >
                  Collection Rate
                </Typography>

                <Typography
                  sx={{
                    mt: 1,
                    fontSize: {
                      xs: 22,
                      sm: 26,
                    },
                    fontWeight: 800,
                    color: COLORS.orangeDark,
                  }}
                >
                  {collectionRate}%
                </Typography>
              </Box>

              <Box
                sx={{
                  width: 48,
                  height: 48,
                  borderRadius: 2,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "#FFF1E3",
                  color: COLORS.orangeDark,
                }}
              >
                <TrendingUp />
              </Box>
            </Box>
          </CardContent>
        </Card>
      </Grid>
    </Grid>

    <Paper
      elevation={0}
      sx={{
        p: {
          xs: 1.5,
          sm: 2,
        },
        mb: 3,
        borderRadius: 3,
        border: "1px solid #E5E7EB",
      }}
    >
      <Grid
        container
        spacing={2}
        alignItems="center"
      >
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            size="small"
            placeholder="Search by grade class..."
            value={searchTerm}
            onChange={(e) => {
              setSearchTerm(e.target.value);
              setPage(0);
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Search
                    sx={{
                      color: COLORS.orange,
                    }}
                  />
                </InputAdornment>
              ),
            }}
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: 2,
              },
            }}
          />
        </Grid>

        <Grid
          item
          xs={12}
          md={6}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: {
                xs: "stretch",
                md: "flex-end",
              },
              gap: 1,
              flexDirection: {
                xs: "column",
                sm: "row",
              },
            }}
          >
            <Button
              fullWidth={isMobile}
              variant="contained"
              startIcon={<Add />}
              onClick={() => setOpen(true)}
              sx={{
                backgroundColor: COLORS.orange,
                color: COLORS.white,
                borderRadius: 2,
                px: 2.5,
                fontWeight: 700,
                "&:hover": {
                  backgroundColor: COLORS.orangeDark,
                },
              }}
            >
              Add Summary
            </Button>

            <PDFDownloadLink
              document={
                <FinancePDF
                  feesData={filteredData}
                />
              }
              fileName="Semester_Financial_Report.pdf"
              style={{
                textDecoration: "none",
                width: isMobile ? "100%" : "auto",
              }}
            >
              {({ loading: pdfLoading }) => (
                <Button
                  fullWidth={isMobile}
                  variant="outlined"
                  startIcon={<Download />}
                  disabled={pdfLoading}
                  sx={{
                    width: "100%",
                    borderRadius: 2,
                    px: 2.5,
                    fontWeight: 700,
                    color: COLORS.black,
                    borderColor: COLORS.black,
                    "&:hover": {
                      borderColor: COLORS.orange,
                      color: COLORS.orange,
                    },
                  }}
                >
                  {pdfLoading
                    ? "Preparing..."
                    : "Download PDF"}
                </Button>
              )}
            </PDFDownloadLink>
          </Box>
        </Grid>
      </Grid>
    </Paper>

    <Grid
      container
      spacing={2}
      sx={{ mb: 3 }}
    >
      <Grid item xs={12} lg={6}>
        <Paper
          elevation={0}
          sx={{
            p: {
              xs: 1.5,
              sm: 2.5,
            },
            borderRadius: 3,
            border: "1px solid #E5E7EB",
            height: "100%",
          }}
        >
          <Typography
            sx={{
              fontWeight: 800,
              fontSize: 17,
              mb: 2,
            }}
          >
            Fees Expected vs Collected
          </Typography>

          <ResponsiveContainer
            width="100%"
            height={isMobile ? 280 : 350}
          >
            <BarChart
              data={chartData}
              layout="vertical"
              margin={{
                left: 10,
                right: 20,
              }}
            >
              <CartesianGrid
                strokeDasharray="3 3"
                horizontal={false}
              />

              <XAxis
                type="number"
                tickFormatter={(value) =>
                  `$${value.toLocaleString("en-US")}`
                }
              />

              <YAxis
                dataKey="name"
                type="category"
                width={isMobile ? 70 : 100}
                tick={{
                  fontSize: isMobile ? 10 : 12,
                }}
              />

              <Tooltip
                formatter={(value) =>
                  `$${Number(value).toLocaleString("en-US")}`
                }
              />

              <Legend />

              <Bar
                dataKey="expected"
                fill={COLORS.black}
                name="Net Fees"
                radius={[0, 5, 5, 0]}
              />

              <Bar
                dataKey="collected"
                fill={COLORS.orange}
                name="Fees Paid"
                radius={[0, 5, 5, 0]}
              />
            </BarChart>
          </ResponsiveContainer>
        </Paper>
      </Grid>

      <Grid item xs={12} lg={6}>
        <Paper
          elevation={0}
          sx={{
            p: {
              xs: 1.5,
              sm: 2.5,
            },
            borderRadius: 3,
            border: "1px solid #E5E7EB",
            height: "100%",
          }}
        >
          <Typography
            sx={{
              fontWeight: 800,
              fontSize: 17,
              mb: 2,
            }}
          >
            Outstanding Balances
          </Typography>

          <ResponsiveContainer
            width="100%"
            height={isMobile ? 280 : 350}
          >
            <BarChart
              data={chartData}
              layout="vertical"
              margin={{
                left: 10,
                right: 20,
              }}
            >
              <CartesianGrid
                strokeDasharray="3 3"
                horizontal={false}
              />

              <XAxis
                type="number"
                tickFormatter={(value) =>
                  `$${value.toLocaleString("en-US")}`
                }
              />

              <YAxis
                dataKey="name"
                type="category"
                width={isMobile ? 70 : 100}
                tick={{
                  fontSize: isMobile ? 10 : 12,
                }}
              />

              <Tooltip
                formatter={(value) =>
                  `$${Number(value).toLocaleString("en-US")}`
                }
              />

              <Legend />

              <Bar
                dataKey="balance"
                fill={COLORS.camel}
                name="Arrears"
                radius={[0, 5, 5, 0]}
              />
            </BarChart>
          </ResponsiveContainer>
        </Paper>
      </Grid>
    </Grid>

    <Paper
      elevation={0}
      sx={{
        borderRadius: 3,
        border: "1px solid #E5E7EB",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          p: 2,
          backgroundColor: COLORS.black,
          color: COLORS.white,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box>
          <Typography
            sx={{
              fontWeight: 800,
              fontSize: 17,
            }}
          >
            Financial Records
          </Typography>

          <Typography
            sx={{
              color: COLORS.camelLight,
              fontSize: 12,
              mt: 0.3,
            }}
          >
            Manage semester fee summaries
          </Typography>
        </Box>

        <Chip
          label={`${filteredData.length} Records`}
          sx={{
            backgroundColor: COLORS.orange,
            color: COLORS.white,
            fontWeight: 700,
          }}
        />
      </Box>

      {loading ? (
        <Box
          sx={{
            py: 8,
            display: "flex",
            justifyContent: "center",
          }}
        >
          <CircularProgress
            sx={{
              color: COLORS.orange,
            }}
          />
        </Box>
      ) : (
        <>
          <TableContainer
            sx={{
              overflowX: "auto",
            }}
          >
            <Table
              sx={{
                minWidth: 800,
              }}
            >
              <TableHead>
                <TableRow
                  sx={{
                    backgroundColor: "#F4F5F7",
                  }}
                >
                  <TableCell
                    sx={{
                      fontWeight: 800,
                      color: COLORS.black,
                    }}
                  >
                    Class
                  </TableCell>

                  <TableCell
                    sx={{
                      fontWeight: 800,
                      color: COLORS.black,
                    }}
                  >
                    Semester
                  </TableCell>

                  <TableCell
                    sx={{
                      fontWeight: 800,
                      color: COLORS.black,
                    }}
                  >
                    Year
                  </TableCell>

                  <TableCell
                    sx={{
                      fontWeight: 800,
                      color: COLORS.black,
                    }}
                  >
                    Net Fees
                  </TableCell>

                  <TableCell
                    sx={{
                      fontWeight: 800,
                      color: COLORS.black,
                    }}
                  >
                    Fees Paid
                  </TableCell>

                  <TableCell
                    sx={{
                      fontWeight: 800,
                      color: COLORS.black,
                    }}
                  >
                    Arrears
                  </TableCell>

                  <TableCell
                    align="right"
                    sx={{
                      fontWeight: 800,
                      color: COLORS.black,
                    }}
                  >
                    Actions
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {filteredData
                  .slice(
                    page * rowsPerPage,
                    page * rowsPerPage + rowsPerPage
                  )
                  .map((row) => (
                    <TableRow
                      key={row.id}
                      hover
                      sx={{
                        transition: "0.2s",
                        "&:hover": {
                          backgroundColor: "#FFF8F0",
                        },
                      }}
                    >
                      <TableCell>
                        <Typography
                          sx={{
                            fontWeight: 700,
                          }}
                        >
                          {row.grade_class_name}
                        </Typography>
                      </TableCell>

                      <TableCell>
                        <Chip
                          size="small"
                          label={row.semester}
                          sx={{
                            backgroundColor:
                              row.semester === "First"
                                ? "#FFF1E3"
                                : "#E8D5BD",
                            color: COLORS.black,
                            fontWeight: 700,
                          }}
                        />
                      </TableCell>

                      <TableCell>
                        {row.year}
                      </TableCell>

                      <TableCell>
                        <Typography
                          sx={{
                            fontWeight: 700,
                          }}
                        >
                          $
                          {Number(
                            row.fees_expected || 0
                          ).toLocaleString("en-US")}
                        </Typography>
                      </TableCell>

                      <TableCell>
                        <Typography
                          sx={{
                            color: COLORS.green,
                            fontWeight: 700,
                          }}
                        >
                          $
                          {Number(
                            row.fees_collected || 0
                          ).toLocaleString("en-US")}
                        </Typography>
                      </TableCell>

                      <TableCell>
                        <Typography
                          sx={{
                            color:
                              Number(row.balance || 0) > 0
                                ? COLORS.red
                                : COLORS.green,
                            fontWeight: 700,
                          }}
                        >
                          $
                          {Number(
                            row.balance || 0
                          ).toLocaleString("en-US")}
                        </Typography>
                      </TableCell>

                      <TableCell align="right">
                        <IconButton
                          onClick={() =>
                            handleDelete(row.id)
                          }
                          sx={{
                            color: COLORS.red,
                            "&:hover": {
                              backgroundColor: "#FDECEC",
                            },
                          }}
                        >
                          <Delete />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}

                {filteredData.length === 0 && (
                  <TableRow>
                    <TableCell
                      colSpan={7}
                      align="center"
                      sx={{
                        py: 6,
                        color: COLORS.grayDark,
                      }}
                    >
                      No financial records found.
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>

          <Divider />

          <TablePagination
            component="div"
            count={filteredData.length}
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            rowsPerPageOptions={[6, 10, 20, 50]}
          />
        </>
      )}
    </Paper>

    <Modal
      open={open}
      onClose={() => setOpen(false)}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: {
            xs: "calc(100% - 28px)",
            sm: 500,
          },
          maxHeight: "90vh",
          overflowY: "auto",
          backgroundColor: COLORS.white,
          borderRadius: 3,
          boxShadow: 24,
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            p: 2.5,
            backgroundColor: COLORS.black,
            color: COLORS.white,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Box>
            <Typography
              sx={{
                fontWeight: 800,
                fontSize: 19,
              }}
            >
              Add Fees Summary
            </Typography>

            <Typography
              sx={{
                color: COLORS.camelLight,
                fontSize: 12,
                mt: 0.3,
              }}
            >
              Create a new semester financial record
            </Typography>
          </Box>

          <IconButton
            onClick={() => setOpen(false)}
            sx={{
              color: COLORS.white,
            }}
          >
            <Close />
          </IconButton>
        </Box>

        <Box
          sx={{
            p: {
              xs: 2,
              sm: 3,
            },
          }}
        >
          <TextField
            select
            label="Grade Class"
            fullWidth
            margin="normal"
            value={formData.grade_class}
            onChange={(e) =>
              setFormData({
                ...formData,
                grade_class: e.target.value,
              })
            }
          >
            {gradeClasses.map((gc) => (
              <MenuItem
                key={gc.id}
                value={gc.id}
              >
                {gc.name}
              </MenuItem>
            ))}
          </TextField>

          <TextField
            select
            label="Semester"
            fullWidth
            margin="normal"
            value={formData.semester}
            onChange={(e) =>
              setFormData({
                ...formData,
                semester: e.target.value,
              })
            }
          >
            {semesters.map((semester) => (
              <MenuItem
                key={semester}
                value={semester}
              >
                {semester}
              </MenuItem>
            ))}
          </TextField>

          <TextField
            type="number"
            label="Year"
            fullWidth
            margin="normal"
            value={formData.year}
            onChange={(e) =>
              setFormData({
                ...formData,
                year: e.target.value,
              })
            }
          />

          <Box
            sx={{
              display: "flex",
              gap: 1,
              justifyContent: "flex-end",
              mt: 3,
            }}
          >
            <Button
              variant="outlined"
              onClick={() => setOpen(false)}
              sx={{
                borderRadius: 2,
                color: COLORS.black,
                borderColor: "#D1D5DB",
              }}
            >
              Cancel
            </Button>

            <Button
              variant="contained"
              onClick={handleSubmit}
              disabled={saving}
              sx={{
                borderRadius: 2,
                backgroundColor: COLORS.orange,
                fontWeight: 700,
                "&:hover": {
                  backgroundColor: COLORS.orangeDark,
                },
              }}
            >
              {saving
                ? "Saving..."
                : "Save Summary"}
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  </Box>
</Box>


);
};

export default FinanceDashboard;





// import React, { useEffect, useState } from "react";
// import api from "../../api/api";
// import Swal from "sweetalert2";
// import {
//   Box,
//   Typography,
//   Paper,
//   Button,
//   Modal,
//   TextField,
//   MenuItem,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   TablePagination,
//   Grid,
//   IconButton,
//   InputAdornment,
// } from "@mui/material";
// import { Download, Search, Delete } from "@mui/icons-material";
// import {
//   BarChart,
//   Bar,
//   XAxis,
//   YAxis,
//   Tooltip,
//   ResponsiveContainer,
//   Legend,
// } from "recharts";
// import jsPDF from "jspdf";
// import logo from "./logoo.png";

// const semesters = ["First", "Second"];
// const currentYear = new Date().getFullYear();

// const FinanceDashboard = () => {
//   const [feesData, setFeesData] = useState([]);
//   const [formData, setFormData] = useState({
//     grade_class: "",
//     semester: "",
//     year: currentYear,
//   });
//   const [gradeClasses, setGradeClasses] = useState([]);
//   const [open, setOpen] = useState(false);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(6);

//   const fetchFees = async () => {
//     const res = await api.get("/fees-per-grade-class/");
//     setFeesData(res.data);
//   };

//   const fetchGradeClasses = async () => {
//     const res = await api.get("/api/users/grade-classes/");
//     setGradeClasses(res.data);
//   };

//   const handleSubmit = async () => {
//     await api.post("/fees-per-grade-class/", formData);
//     setOpen(false);
//     fetchFees();
//   };

//   const handleDelete = async (id) => {
//     const result = await Swal.fire({
//       title: "Are you sure?",
//       text: "You won’t be able to revert this!",
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonColor: "#d33",
//       cancelButtonColor: "#3085d6",
//       confirmButtonText: "Yes, delete it!",
//     });

//     if (result.isConfirmed) {
//       try {
//         await api.delete(`/fees-per-grade-class/${id}/`);
//         setFeesData((prev) => prev.filter((item) => item.id !== id));
//         Swal.fire("Deleted!", "Record has been deleted.", "success");
//       } catch (error) {
//         console.error("Failed to delete:", error);
//         Swal.fire("Error", "Failed to delete record. Please try again.", "error");
//       }
//     }
//   };

// const downloadPDF = () => {
//   const doc = new jsPDF("p", "mm", "a4");

//   const img = new Image();
//   img.src = logo;

//   img.onload = () => {
//     const canvas = document.createElement("canvas");
//     canvas.width = img.width;
//     canvas.height = img.height;
//     const ctx = canvas.getContext("2d");
//     ctx.drawImage(img, 0, 0);
//     const logoBase64 = canvas.toDataURL("image/png");

//     let y = 20;

//     // Header background
//     doc.setFillColor(230, 230, 230);
//     doc.rect(10, 10, 190, 30, "F");

//     // Logo and heading centered
//     doc.addImage(logoBase64, "PNG", 14, 14, 20, 20);
//     doc.setFontSize(18);
//     doc.setFont("helvetica", "bold");
//     doc.text("Messiah Mission Institute", 105, 20, { align: "center" });

//     doc.setFontSize(11);
//     doc.setFont("helvetica", "normal");
//     doc.text("Morris' Farm, Paynesville Monrovia, Liberia", 105, 26, { align: "center" });
//     doc.text("Contact: +231-770-216-549 / +231-770-405-998 / +231-886-484-807 | messiahmissioninstitute@gmail.com", 105, 31, { align: "center" });

//     // Title
//     doc.setFontSize(13);
//     doc.setFont("helvetica", "bold");
//     doc.setTextColor(0);
//     doc.text("Semester Financial Summary Report", 105, 45, { align: "center" });

//     // Table setup
//     y = 55;
//     const headers = ["#", "Class", "Semester", "Year", "Net Fees", "Fees Paid", "Arrears"];
//     const colWidths = [10, 35, 25, 20, 30, 30, 30];
//     const totalTableWidth = colWidths.reduce((a, b) => a + b, 0);
//     const pageWidth = doc.internal.pageSize.getWidth();
//     const startX = (pageWidth - totalTableWidth) / 2;

//     // Draw header background
//     doc.setFillColor(220, 235, 255);
//     doc.rect(startX, y - 7, totalTableWidth, 10, "F");

//     doc.setFont("helvetica", "bold");
//     doc.setFontSize(11);
//     let x = startX;

//     // Draw vertical lines & headers centered
//     headers.forEach((header, i) => {
//       // Vertical line for the start of each column except first
//       if (i !== 0) {
//         doc.setDrawColor(180);
//         doc.line(x, y - 7, x, y + 3 + 7 * feesData.length); // height approx table height
//       }

//       // Centered header text inside column
//       const colCenter = x + colWidths[i] / 2;
//       doc.text(header, colCenter, y, { align: "center" });

//       x += colWidths[i];
//     });

//     // Horizontal line below headers
//     doc.setDrawColor(180);
//     doc.line(startX, y + 2, startX + totalTableWidth, y + 2);

//     y += 8;

//     // Table rows, centered text & vertical lines
//     doc.setFont("helvetica", "normal");
//     doc.setFontSize(10);

//     feesData.forEach((row, idx) => {
//       let x = startX;

//       // Draw vertical lines before each column except first
//       for (let i = 1; i < colWidths.length; i++) {
//         doc.setDrawColor(230);
//         doc.line(x, y - 3, x, y + 7);
//         x += colWidths[i - 1];
//       }

//       x = startX;
//       const rowData = [
//         String(idx + 1),
//         row.grade_class_name,
//         row.semester,
//         String(row.year),
//         `$${row.fees_expected}`,
//         `$${row.fees_collected}`,
//         `$${row.balance}`,
//       ];

//       rowData.forEach((text, i) => {
//         const colCenter = x + colWidths[i] / 2;
//         doc.text(text, colCenter, y, { align: "center" });
//         x += colWidths[i];
//       });

//       y += 7;

//       // Add new page if overflow
//       if (y > 260) {
//         doc.addPage();
//         y = 20;
//       }
//     });

//     // Signature line & text centered with table
//     if (y < 240) y = 240;
//     doc.setDrawColor(180);
//     doc.line(startX, y, startX + 66, y); // signature line
//     doc.setFont("helvetica", "italic");
//     doc.text("Business Manager", startX + 33, y + 5, { align: "center" });
//     doc.setFont("helvetica", "bold");
//     doc.text("The Finance Department", startX + 33, y + 11, { align: "center" });

//     doc.save("Semester_Financial_Report.pdf");
//   };
// };


//   useEffect(() => {
//     fetchFees();
//     fetchGradeClasses();
//   }, []);

//   const filteredData = feesData.filter((item) =>
//     item.grade_class_name?.toLowerCase().includes(searchTerm.toLowerCase())
//   );

//   const handleChangePage = (event, newPage) => setPage(newPage);
//   const handleChangeRowsPerPage = (event) => {
//     setRowsPerPage(+event.target.value);
//     setPage(0);
//   };

//   return (
//     <Box p={3}>
//       <Typography variant="h4" gutterBottom>
//         Semester Fees Summary
//       </Typography>

//       <Grid container spacing={2} justifyContent="space-between" alignItems="center">
//         <Grid item xs={12} md={6}>
//           <TextField
//             placeholder="Search grade class"
//             fullWidth
//             variant="outlined"
//             InputProps={{
//               startAdornment: (
//                 <InputAdornment position="start">
//                   <Search />
//                 </InputAdornment>
//               ),
//             }}
//             onChange={(e) => setSearchTerm(e.target.value)}
//           />
//         </Grid>

//         <Grid item xs={12} md={6} container justifyContent="flex-end" spacing={1}>
//           <Grid item>
//             <Button variant="contained" onClick={() => setOpen(true)}>
//               Add Summary
//             </Button>
//           </Grid>
//           <Grid item>
//             <Button variant="outlined" startIcon={<Download />} onClick={downloadPDF}>
//               Download PDF
//             </Button>
//           </Grid>
//         </Grid>
//       </Grid>

//       <Grid container spacing={2} mt={3}>
//         <Grid item xs={12} md={6}>
//           <Paper elevation={3} sx={{ p: 2 }}>
//             <Typography variant="h6">Fees Expected vs Collected</Typography>
//             <ResponsiveContainer width="100%" height={300}>
//               <BarChart data={feesData} layout="vertical">
//                 <XAxis type="number" hide />
//                 <YAxis dataKey="grade_class_name" type="category" />
//                 <Tooltip />
//                 <Legend />
//                 <Bar dataKey="fees_expected" fill="#1976d2" name="Net Fees" />
//                 <Bar dataKey="fees_collected" fill="#2e7d32" name="Fees Paid" />
//               </BarChart>
//             </ResponsiveContainer>
//           </Paper>
//         </Grid>
//         <Grid item xs={12} md={6}>
//           <Paper elevation={3} sx={{ p: 2 }}>
//             <Typography variant="h6">Outstanding Balances</Typography>
//             <ResponsiveContainer width="100%" height={300}>
//               <BarChart data={feesData} layout="vertical">
//                 <XAxis type="number" hide />
//                 <YAxis dataKey="grade_class_name" type="category" />
//                 <Tooltip />
//                 <Legend />
//                 <Bar dataKey="balance" fill="#d32f2f" name="Arrears" />
//               </BarChart>
//             </ResponsiveContainer>
//           </Paper>
//         </Grid>
//       </Grid>

//       <Paper sx={{ mt: 4 }}>
// <TableContainer>
//   <Table>
//     <TableHead sx={{ backgroundColor: '#e0e0e0' }}>
//       <TableRow>
//         <TableCell>Class</TableCell>
//         <TableCell>Semester</TableCell>
//         <TableCell>Year</TableCell>
//         <TableCell>Net Fees</TableCell>
//         <TableCell>Fees Paid</TableCell>
//         <TableCell>Arrears</TableCell>
//         <TableCell align="right">Actions</TableCell>
//       </TableRow>
//     </TableHead>
//     <TableBody>
//       {filteredData
//         .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
//         .map((row) => (
//           <TableRow
//             key={row.id}
//             sx={{
//               '&:hover': {
//                 backgroundColor: '#e3f2fd', // light blue on hover
//               },
//             }}
//           >
//             <TableCell sx={{ backgroundColor: '#011120ff', color: '#ffffff' }}>
//               {row.grade_class_name}
//             </TableCell>
//             <TableCell>{row.semester}</TableCell>
//             <TableCell>{row.year}</TableCell>
//             <TableCell style={{ color: 'blue' }}>${row.fees_expected}</TableCell>
//             <TableCell style={{ color: 'green' }}>${row.fees_collected}</TableCell>
//             <TableCell style={{ color: 'red' }}>${row.balance}</TableCell>
//             <TableCell align="right">
//               <IconButton
//                 color="error"
//                 onClick={() => handleDelete(row.id)}
//                 aria-label="delete"
//               >
//                 <Delete />
//               </IconButton>
//             </TableCell>
//           </TableRow>
//         ))}
//     </TableBody>
//   </Table>
// </TableContainer>

//         <TablePagination
//           component="div"
//           count={filteredData.length}
//           page={page}
//           onPageChange={handleChangePage}
//           rowsPerPage={rowsPerPage}
//           onRowsPerPageChange={handleChangeRowsPerPage}
//         />
//       </Paper>

//       <Modal open={open} onClose={() => setOpen(false)}>
//         <Box
//           sx={{
//             position: "absolute",
//             top: "50%",
//             left: "50%",
//             transform: "translate(-50%, -50%)",
//             width: 400,
//             bgcolor: "background.paper",
//             p: 4,
//             boxShadow: 24,
//             borderRadius: 2,
//           }}
//         >
//           <Typography variant="h6" mb={2}>
//             Add Fees Summary
//           </Typography>
//           <TextField
//             select
//             label="Grade Class"
//             fullWidth
//             margin="normal"
//             value={formData.grade_class}
//             onChange={(e) => setFormData({ ...formData, grade_class: e.target.value })}
//           >
//             {gradeClasses.map((gc) => (
//               <MenuItem key={gc.id} value={gc.id}>
//                 {gc.name}
//               </MenuItem>
//             ))}
//           </TextField>

//           <TextField
//             select
//             label="Semester"
//             fullWidth
//             margin="normal"
//             value={formData.semester}
//             onChange={(e) => setFormData({ ...formData, semester: e.target.value })}
//           >
//             {semesters.map((sem) => (
//               <MenuItem key={sem} value={sem}>
//                 {sem}
//               </MenuItem>
//             ))}
//           </TextField>

//           <TextField
//             type="number"
//             label="Year"
//             fullWidth
//             margin="normal"
//             value={formData.year}
//             onChange={(e) => setFormData({ ...formData, year: e.target.value })}
//           />

//           <Box textAlign="right" mt={2}>
//             <Button onClick={handleSubmit} variant="contained">
//               Submit
//             </Button>
//           </Box>
//         </Box>
//       </Modal>
//     </Box>
//   );
// };

// export default FinanceDashboard;